type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function NavigationMapPointerIcon(props: Props) {
  return (
    <svg
      width={props.width ?? 10}
      height={props.height ?? 13}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="M4.58605 0C2.06908 0 0 1.99712 0 4.84615c0 1.01667.235287 1.72404.672474 2.50738L4.27737 13.8151c.06205.1141.18048.1849.30868.1849s.24663-.0708.30868-.1853l3.6049-6.46149c.43718-.78334.67247-1.49039.67247-2.50706C9.17241 1.99712 7.10302 0 4.58636 0h-.00031Zm0 2.51282c1.16888 0 2.11664.96442 2.11664 2.15385 0 1.18942-.94776 2.15384-2.11664 2.15384-1.16888 0-2.11664-.96442-2.11664-2.15384 0-1.18943.94776-2.15385 2.11664-2.15385Z"
          fill={props.fill || '#593B37'}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h9.17241v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
